import { useState, useEffect } from "react";
import AdminLayout from "../../layouts/AdminLayout";
import API from "../../services/api";
const MONTSERRAT = `@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&display=swap');`;

function Notifications() {
  const [notifications, setNotifications] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchNotifications = async () => {
      try {
        setLoading(true);
        const token = localStorage.getItem("token");
        const res = await API.get("/admin/notifications", { headers: { Authorization: `Bearer ${token}` } });
        if (res.data.success) setNotifications(res.data.data || []);
      } catch (err) {
        console.error("Error connecting server notification stack:", err);
      } finally {
        setLoading(false);
      }
    };
    fetchNotifications();
  }, []);

  return (
   <AdminLayout>
  <style>{MONTSERRAT + ` * { font-family: 'Montserrat', sans-serif !important; }`}</style>
  <div className="mb-8">
        <h1 className="text-4xl font-bold text-gray-800">Notifications Center</h1>
        <p className="text-gray-500 mt-2">Monitor alerts, approvals and project updates.</p>
      </div>

      <div className="grid grid-cols-1 md:grid-cols-2 xl:grid-cols-4 gap-6 mb-8">
        <div className="bg-white rounded-3xl shadow-lg p-6">
          <h3 className="text-gray-500">Total Notifications</h3>
          <h2 className="text-4xl font-bold text-purple-600 mt-2">{loading ? "..." : notifications.length}</h2>
        </div>
        <div className="bg-white rounded-3xl shadow-lg p-6">
          <h3 className="text-gray-500">Unread</h3>
          <h2 className="text-4xl font-bold text-red-500 mt-2">{notifications.filter((n) => n.status === "Unread").length}</h2>
        </div>
        <div className="bg-white rounded-3xl shadow-lg p-6">
          <h3 className="text-gray-500">Read</h3>
          <h2 className="text-4xl font-bold text-green-500 mt-2">{notifications.filter((n) => n.status === "Read").length}</h2>
        </div>
        <div className="bg-white rounded-3xl shadow-lg p-6">
          <h3 className="text-gray-500">Today's Alerts</h3>
          <h2 className="text-4xl font-bold text-blue-500 mt-2">{notifications.filter(n => n.isToday).length || 0}</h2>
        </div>
      </div>

      <div className="bg-white rounded-3xl shadow-lg p-8">
        <h2 className="text-2xl font-bold text-gray-800 mb-6">Recent Notifications</h2>
        <div className="overflow-x-auto">
          <table className="w-full">
            <thead>
              <tr className="border-b">
                <th className="text-left py-4">Title</th><th className="text-left">Message</th><th className="text-left">Module</th><th className="text-left">Created By</th><th className="text-left">Date</th><th className="text-left">Status</th>
              </tr>
            </thead>
            <tbody>
              {notifications.map((item) => (
                <tr key={item.id} className="border-b">
                  <td className="py-4 font-bold text-gray-800">{item.title}</td>
                  <td className="text-gray-600 text-sm">{item.message}</td>
                  <td><span className="text-xs font-semibold bg-slate-100 text-slate-600 px-2.5 py-1 rounded-md">{item.module}</span></td>
                  <td className="text-sm text-gray-600">{item.createdBy}</td>
                  <td className="text-xs text-gray-400">{item.date}</td>
                  <td>
                    <span className={`px-3 py-1 rounded-full text-xs font-bold ${item.status === "Unread" ? "bg-red-100 text-red-600" : "bg-green-100 text-green-600"}`}>{item.status}</span>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      </div>
    </AdminLayout>
  );
}

export default Notifications;